import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { myApprovalsConfig } from './myApprovalsConfig';
import { createMyApprovalsValidationSchema } from './myApprovalsValidation';

/**
 * Initialize the My Approvals module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  myApprovalsConfig,
  createMyApprovalsValidationSchema
);

/**
 * Create the MyApprovalsPage using the generic module page factory
 */
const MyApprovalsPage = createModulePage(
  initializedConfig,
  {
    displayName: 'MyApprovalsPage',
    description: 'My Approvals Management System - View and manage approvals assigned to you'
  }
);

export default MyApprovalsPage;
